import Vue from 'vue'
import Vuetify, {
  VAlert,
  VApp,
  VBreadcrumbs,
  VBtn,
  VCard,
  VCardText,
  VCardTitle,
  VCheckbox,
  VChip,
  VContainer,
  VDatePicker,
  VDialog,
  VDivider,
  VForm,
  VIcon,
  VList,
  VMessages,
  VProgressLinear,
  VRadio,
  VRadioGroup,
  VSelect,
  VTextarea,
  VTextField} from 'vuetify/lib';

Vue.use(Vuetify, {
    components: {
      VAlert,
      VApp,
      VBreadcrumbs,
      VBtn,
      VCard,
      VCardText,
      VCardTitle,
      VCheckbox,
      VChip,
      VContainer,
      VDatePicker,
      VDialog,
      VDivider,
      VForm,
      VIcon,
      VList,
      VMessages,
      VProgressLinear,
      VRadio,
      VRadioGroup,
      VSelect,
      VTextarea,
      VTextField,
}});

import '~/css/shared/vuetify/vuetify.css';

export default new Vuetify({
  icons: {
    iconfont: 'fa',
  },
  theme: {
    themes: {
      light: {
        primary: '#008489',
        secondary: '#008489'
      }
    },
  },
});
